'use client'

import { useEffect, useState } from 'react'
import { MediaImageStandard, Typography } from 'components/Contentful'

const parseEndDate = (time) => {
  if (!time) return null
  const [datePart, timePart = '00:00:00'] = time.trim().split(' ')
  const [day, month, year] = datePart.split('/').map(Number)
  const [hours, minutes, seconds] = timePart.split(':').map(Number)
  const date = new Date(year, (month || 1) - 1, day, hours || 0, minutes || 0, seconds || 0)
  return Number.isNaN(date.getTime()) ? null : date
}

const pad = (value) => String(value).padStart(2, '0')

const getRemaining = (endDate) => {
  if (!endDate) return null
  const diff = Math.max(0, endDate.getTime() - Date.now())
  const totalSeconds = Math.floor(diff / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  return `${pad(days)}:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}

const Countdown = ({ time = '20/05/2026 12:30:30', image }) => {
  const endDate = parseEndDate(time)
  const [remaining, setRemaining] = useState(() => getRemaining(endDate))

  useEffect(() => {
    if (!endDate) return undefined
    setRemaining(getRemaining(endDate))
    const intervalId = setInterval(() => {
      const next = getRemaining(endDate)
      setRemaining(next)
      if (next === '00:00:00:00') {
        clearInterval(intervalId)
      }
    }, 1000)
    return () => clearInterval(intervalId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time])

  return (
    <div className="relative flex flex-col items-center text-center mx-auto bg-[#3B6AF7] p-3 rounded-[8px] lg:mr-[120px]">
      {image && (
        <MediaImageStandard
          className="absolute! right-[10px] bottom-[calc(100%-70px)]"
          alt={image.alt}
          content={image.mediaContent}
          layout="fixed"
          width={230}
          height={227}
          fetchPriority="high"
          preload={true}
          objectFit="fill"
        />
      )}
      <Typography
        content={'Lock in your entry'}
        className="self-start text-left text-[#F8F9FC] font-ultramarine font-bold text-[18px] leading-[1.2] tracking-[0.36px] my-[10px]"
      />
      {remaining && (
        <div className="flex items-start justify-center bg-white rounded-[8px] pt-[10px] pb-[10px]">
          {remaining.split(':').map((unit, index, arr) => {
            const labels = ['Days', 'Hours', 'Minutes', 'Seconds']
            return (
              <span key={index} className="flex items-start">
                <span className="flex flex-col items-center w-[72px]">
                  <Typography
                    content={unit}
                    className="text-center text-black font-ultramarine font-bold text-[40px] leading-[1.3]"
                  />
                  <Typography
                    content={labels[index]}
                    className="text-center text-black font-ultramarine font-normal text-[14px] leading-[1.4]"
                  />
                </span>
                {index < arr.length - 1 && (
                  <span className="flex items-center justify-center h-[52px] w-[16px]">
                    <Typography
                      content={':'}
                      className="text-center text-black font-['Inter'] font-normal text-[24.617px] leading-[32.822px] tracking-[0.072px]"
                    />
                  </span>
                )}
              </span>
            )
          })}
        </div>
      )}
    </div>
  )
}

export { Countdown }
